export default "__VITE_ASSET__84a02d8a__"